"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfiguredJsonRpcProvider = void 0;
const ethers_1 = require("ethers");
class ConfiguredJsonRpcProvider extends ethers_1.JsonRpcProvider {
    constructor(url, network, maxLogsPerBatch = 100) {
        const options = {
            staticNetwork: network,
            batchMaxCount: maxLogsPerBatch,
        };
        super(url, network, options);
    }
}
exports.ConfiguredJsonRpcProvider = ConfiguredJsonRpcProvider;
